var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40983 22.6804C0.757922 22.0284 0.757922 20.9715 1.40983 20.3196L10.0489 11.6805L1.40983 3.04146C0.757923 2.38955 0.757923 1.33261 1.40983 0.680701C2.06173 0.0287962 3.11868 0.0287962 3.77058 0.680701L13.59 10.5001C14.2419 11.1521 14.2419 12.209 13.59 12.8609L3.77058 22.6804C3.11868 23.3323 2.06173 23.3323 1.40983 22.6804Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.97e5876077f5dfd173cb51956d1008e5.svg";
export { ForwardRef as ReactComponent };